<template>
  <div id="checkout-section-information" class="checkout__accordion" v-if="!hide">
    <a
      href="#"
      class="checkout__accordion__title checkout__accordion__title--done"
      v-if="completed"
      @click="edit"
      >{{ __("Information") }}</a
    >
    <span class="checkout__accordion__title" v-else-if="!completed">{{
      __("Information")
    }}</span>

    <div class="checkout__block" v-if="!completed">
      <form class="form">
        <div class="wrapper">
          <div class="row row--reset">
            <div
              class="col mq-tab--12 js-billing"
              v-bind:class="{
                'col--12':
                  !requirements.includes('delivery.name') &&
                  !requirements.includes('delivery.address_line_1') &&
                  !requirements.includes('delivery.address_line_2') &&
                  !requirements.includes('delivery.city') &&
                  !requirements.includes('delivery.county') &&
                  !requirements.includes('delivery.postcode'),
                'col--6':
                  requirements.includes('delivery.name') ||
                  requirements.includes('delivery.address_line_1') ||
                  requirements.includes('delivery.address_line_2') ||
                  requirements.includes('delivery.city') ||
                  requirements.includes('delivery.county') ||
                  requirements.includes('delivery.postcode'),
              }"
            >
              <div class="col__inner">
                <div class="checkout__box">
                  <div
                    v-if="
                      tenant.settings.config.booking_confirmation &&
                      tenant.settings.config.booking_confirmation.information &&
                      tenant.settings.config.booking_confirmation.information
                        .enabled &&
                      tenant.settings.config.booking_confirmation.information
                        .enabled == 'on'
                    "
                  >
                    <h2
                      class="checkout__box__ttl"
                      v-if="
                        tenant.settings.config.booking_confirmation.information
                          .title
                      "
                    >
                      {{
                        tenant.settings.config.booking_confirmation.information
                          .title
                      }}
                    </h2>

                    <div
                      v-if="
                        tenant.settings.config.booking_confirmation.information
                          .text
                      "
                    >
                      <p
                        v-for="line in tenant.settings.config.booking_confirmation.information.text.split(
                          '\n'
                        )"
                        :key="line"
                      >
                        {{ line }}
                      </p>
                    </div>

                    <div class="form__field">
                      <textarea
                        v-model="fields.notes"
                        class="form__input form__input--secondary"
                        rows="5"
                      ></textarea>
                    </div>
                  </div>

                  <h2 id="billing-address-heading" class="checkout__box__ttl">
                    {{ __("Billing Address") }}
                  </h2>

                  <div class="form__field">
                    <input
                      type="text"
                      id="b_first_name"
                      name="b_first_name"
                      class="form__input form__input--secondary"
                      :placeholder="__('First name')"
                      v-model="fields.billing.first_name"
                    />

                    <div
                      class="form__error"
                      v-if="
                        typeof errors['fields.billing.first_name'] != 'undefined'
                      "
                    >
                      <p
                        v-for="(e, i) in errors['fields.billing.first_name']"
                        :key="'billing_first_name' + i"
                        v-html="e"
                      ></p>
                    </div>
                  </div>

                  <div class="form__field">
                    <input
                      type="text"
                      id="b_surname"
                      name="b_surname"
                      class="form__input form__input--secondary"
                      :placeholder="__('Last name')"
                      v-model="fields.billing.surname"
                    />

                    <div
                      class="form__error"
                      v-if="
                        typeof errors['fields.billing.surname'] != 'undefined'
                      "
                    >
                      <p
                        v-for="(e, i) in errors['fields.billing.surname']"
                        :key="'billing_surname' + i"
                        v-html="e"
                      ></p>
                    </div>
                  </div>
                  <div class="form__field">
                    <input
                      type="text"
                      id="b_email"
                      name="b_email"
                      class="form__input form__input--secondary"
                      :placeholder="__('Email Address')"
                      v-model="fields.billing.email"
                      v-if="requirements.includes('billing.email')"
                    />

                    <div
                      class="form__error"
                      v-if="
                        typeof errors['fields.billing.email'] != 'undefined'
                      "
                    >
                      <p
                        v-for="(e, i) in errors['fields.billing.email']"
                        :key="'billing_email' + i"
                        v-html="e"
                      ></p>
                    </div>
                  </div>

                  <div class="form__field">
                    <input
                      type="text"
                      id="confirm_email"
                      name="confirm_email"
                      class="form__input form__input--secondary"
                      :placeholder="__('Confirm Email Address')"
                      v-model="fields.billing.email_confirmation"
                      v-if="requirements.includes('billing.email_confirmation')"
                    />

                    <div
                      class="form__error"
                      v-if="
                        typeof errors['fields.billing.email'] != 'undefined'
                      "
                    >
                      <p
                        v-for="(e, i) in errors[
                          'fields.billing.email_confirmation'
                        ]"
                        :key="'email_confirmation' + i"
                        v-html="e"
                      ></p>
                    </div>
                  </div>
                  <div class="form__field" v-if="$website.tenant_settings.billing_telephone_enabled === '1'">
                    <input
                      type="text"
                      id="b_phone"
                      name="b_phone"
                      class="form__input form__input--secondary"
                      :placeholder="__('Phone Number')"
                      v-model="fields.billing.telephone"
                      v-if="requirements.includes('billing.telephone')"
                    />

                    <div
                      class="form__error"
                      v-if="
                        typeof errors['fields.billing.telephone'] != 'undefined'
                      "
                    >
                      <p
                        v-for="(e, i) in errors['fields.billing.telephone']"
                        :key="'billing_telephone' + i"
                        v-html="e"
                      ></p>
                    </div>
                  </div>

                  <div class="form__field mt-10" id="google-address-autocomplete-billing-wrapper"
                    v-if="$website.tenant_settings.google_address_autocomplete_enabled">
                    <i class="fas fa-search fa-2x text-black search-icon"></i>
                    <i class="fas fa-times fa-2x text-black clear-icon" @click="clearAddress" v-show="showSearchClearButton"></i>
                    <google-address-autocomplete
                      ref="googleAddressAutocompleteBillingField"
                      id="google-address-autocomplete-billing"
                      classname="form__input form__input--secondary"
                      placeholder="Search for your address"
                      :country="$website.tenant_settings.google_address_autocomplete_countries"
                      v-on:placechanged="getAddressData"
                      v-on:inputChange="onAddressSearchChange"
                    />
                  </div>

                  <div class="form__field">
                    <input
                      type="text"
                      id="b_address_line_1"
                      name="b_address_line_1"
                      class="form__input form__input--secondary"
                      :placeholder="__('Address Line 1')"
                      v-model="fields.billing.address_line_1"
                      v-if="requirements.includes('billing.address_line_1')"
                    />

                    <div
                      class="form__error"
                      v-if="
                        typeof errors['fields.billing.address_line_1'] !=
                        'undefined'
                      "
                    >
                      <p
                        v-for="(e, i) in errors[
                          'fields.billing.address_line_1'
                        ]"
                        :key="'billing_address_line_1' + i"
                        v-html="e"
                      ></p>
                    </div>
                  </div>
                  <div class="form__field">
                    <input
                      type="text"
                      id="b_address_line_2"
                      name="b_address_line_2"
                      class="form__input form__input--secondary"
                      :placeholder="__('Address Line 2')"
                      v-model="fields.billing.address_line_2"
                      v-if="requirements.includes('billing.address_line_2')"
                    />

                    <div
                      class="form__error"
                      v-if="
                        typeof errors['fields.billing.address_line_2'] !=
                        'undefined'
                      "
                    >
                      <p
                        v-for="(e, i) in errors[
                          'fields.billing.address_line_2'
                        ]"
                        :key="'billing_address_line_2' + i"
                        v-html="e"
                      ></p>
                    </div>
                  </div>
                  <div class="form__field">
                    <input
                      type="text"
                      id="b_city"
                      name="b_city"
                      class="form__input form__input--secondary"
                      :placeholder="__('City')"
                      v-model="fields.billing.city"
                      v-if="requirements.includes('billing.city')"
                    />

                    <div
                      class="form__error"
                      v-if="typeof errors['fields.billing.city'] != 'undefined'"
                    >
                      <p
                        v-for="(e, i) in errors['fields.billing.city']"
                        :key="'billing_city' + i"
                        v-html="e"
                      ></p>
                    </div>
                  </div>
                  <div class="form__field">
                    <input
                      type="text"
                      id="b_county"
                      name="b_county"
                      class="form__input form__input--secondary"
                      :placeholder="__('County')"
                      v-model="fields.billing.county"
                      v-if="requirements.includes('billing.county')"
                    />

                    <div
                      class="form__error"
                      v-if="
                        typeof errors['fields.billing.county'] != 'undefined'
                      "
                    >
                      <p
                        v-for="(e, i) in errors['fields.billing.county']"
                        :key="'billing_county' + i"
                        v-html="e"
                      ></p>
                    </div>
                  </div>

                  <div class="form__field">
                    <input
                      type="text"
                      id="b_postcode"
                      name="b_postcode"
                      maxlength="20"
                      class="form__input form__input--secondary"
                      :placeholder="__('Postcode')"
                      v-model="fields.billing.postcode"
                      v-if="requirements.includes('billing.postcode')"
                    />

                    <div
                      class="form__error"
                      v-if="
                        typeof errors['fields.billing.postcode'] != 'undefined'
                      "
                    >
                      <p
                        v-for="(e, i) in errors['fields.billing.postcode']"
                        :key="'billing_postcode' + i"
                        v-html="e"
                      ></p>
                    </div>
                  </div>

                    <div class="form__field" v-if="$website.tenant_settings.pick_up_name_enabled">
                        <div class="form__field">
                            <input
                                type="text"
                                id="pick_up_first_name"
                                name="pick_up_first_name"
                                maxlength="50"
                                class="form__input form__input--secondary"
                                :placeholder="__('Pick Up First Name')"
                                v-model="fields.pick_up_first_name"
                            />
                            <div class="form__error"
                                v-if="typeof errors['fields.pick_up_first_name'] != 'undefined'"
                            >
                                <p v-for="(e, i) in errors['fields.pick_up_first_name']"
                                    :key="'pick_up_first_name' + i"
                                    v-html="e">
                                </p>
                            </div>
                        </div>

                        <div class="form__field">
                            <input
                                type="text"
                                id="pick_up_last_name"
                                name="pick_up_last_name"
                                maxlength="50"
                                class="form__input form__input--secondary"
                                :placeholder="__('Pick Up Last Name')"
                                v-model="fields.pick_up_last_name"
                            />
                            <div class="form__error"
                                 v-if="typeof errors['fields.pick_up_last_name'] != 'undefined'"
                            >
                                <p v-for="(e, i) in errors['fields.pick_up_last_name']"
                                   :key="'pick_up_last_name' + i"
                                   v-html="e">
                                </p>
                            </div>
                        </div>
                    </div>

                  <div class="form__field" v-if="$website.how_did_you_hear_about_us_enabled">
                      <label class="form__label">How did you hear about us?</label>
                      <select class="form__input  form__input--primary  form__input--full" style="border: 1px solid" v-model="fields.how_did_you_hear_about_us">
                        <option value="null">Please select</option>
                        <option v-for="option in howDidYouHearAboutUsOptions" :value="option.id" v-html="option.name"></option>
                      </select>
                      <input
                        type="text"
                        class="form__input form__input--secondary"
                        :placeholder="__('Please tell us more...')"
                        v-model="fields.how_did_you_hear_about_us_other"
                        v-if="fields.how_did_you_hear_about_us == 10"
                      />
                  </div>

                  <div class="form__field" v-if="$website.tenant_settings.provide_additional_info_enabled">
                    <label v-if="!$website.tenant_settings.provide_additional_info_mandatory">
                      <input
                        type="checkbox"
                        name="provide_additional_info"
                        v-model="fields.provide_additional_info"
                      />
                      {{ $website.tenant_settings.provide_additional_info_label }}
                    </label>

                    <div v-show="fields.provide_additional_info || $website.tenant_settings.provide_additional_info_mandatory">
                      <label for="additional_info" class="font-bold">{{ $website.tenant_settings.provide_additional_info_heading }}</label>
                      <textarea
                        name="additional_info"
                        id="additional_info"
                        class="form__input form__input--secondary"
                        v-model="fields.additional_info"
                        maxlength="1000"
                      />
                      <div
                        class="form__error"
                        v-if="typeof errors['fields.additional_info'] != 'undefined'"
                      >
                        <p
                          v-for="(e, i) in errors['fields.additional_info']"
                          :key="'additional_info' + i"
                          v-html="e"
                        ></p>
                      </div>
                    </div>
                  </div>

                  <div class="form__field">
                    <template v-for="(reservation, index) in reservations">
                      <identification-upload
                        v-if="reservation.requires_id"
                        :key="index"
                        :reservation="reservation"
                        :resIndex="index"
                        :errors="errors"
                      ></identification-upload>
                    </template>

                    <div
                      class="form__error"
                      v-if="typeof errors['id_required'] != 'undefined'"
                    >
                      <p
                        v-for="(e, i) in errors['id_required']"
                        :key="'id_required' + i"
                      >
                        Please make sure you have added the ID (name &amp; ID
                        attachment) for all ticket holders
                      </p>
                    </div>
                  </div>

                  <div class="form__field" v-if="$website.tenant_settings.checkout_terms_conditions_enabled">
                    <label>
                        <input
                            type="checkbox"
                            id="b_terms"
                            name="b_terms"
                            v-model="fields.billing.terms"
                        />
                        <span
                            v-html="$website.tenant_settings.checkout_terms_conditions.replace('<p>', '').replace('<\/p>', '')"
                            v-if="$website.tenant_settings.checkout_terms_conditions">
                        </span>
                        <span
                            v-else>
                            I agree with the terms and conditions in the
                            <a v-if="[63, 150, 151].includes(tenant.id)" target="_blank"
                                href="https://soundrink.com/#/static/ticket-policy">ticketing policy</a>
                            <a v-else target="_blank" href="/terms-and-conditions">ticketing policy</a>. I acknowledge
                            all sales are final unless an event is cancelled. In the event of cancellation service fees
                            are non-refundable.
                        </span>
                    </label>
                    <div
                      class="form__error"
                      v-if="
                        typeof errors['fields.billing.terms'] != 'undefined'
                      "
                    >
                      <p
                        v-for="(e, i) in errors['fields.billing.terms']"
                        :key="'billing_terms' + i"
                        v-html="e"
                      ></p>
                    </div>
                  </div>

                  <div
                    class="form__field"
                    v-if="$website.marketing_opt_in_enabled"
                  >
                    <label>
                      <input
                        type="checkbox"
                        name="b_marketing_opt_in"
                        v-model="fields.billing.marketing_opt_in"
                      />
                      <span
                        v-if="$website.marketing_opt_in_label"
                        v-html="$website.marketing_opt_in_label"
                      ></span>
                      <span
                        v-else
                        v-html="
                          'I would like to receive marketing information from ' +
                          $website.name
                        "
                      ></span>
                    </label>
                    <div
                      class="form__error"
                      v-if="
                        typeof errors['fields.billing.marketing_opt_in'] !=
                        'undefined'
                      "
                    >
                      <p
                        v-for="(e, i) in errors[
                          'fields.billing.marketing_opt_in'
                        ]"
                        :key="'billing_marketing_opt_in' + i"
                        v-html="e"
                      ></p>
                    </div>
                  </div>

                  <div class="form__field" v-if="spectatorCodeOfConduct">
                    <label>
                      <input
                        type="checkbox"
                        v-model="spectator_code_of_conduct"
                      />
                      I agree with the
                      <a target="_blank" href="/spectator-code-of-conduct"
                        >spectator code of conduct</a
                      >
                    </label>
                    <div
                      class="form__error"
                      v-if="spectator_code_of_conduct_error"
                    >
                      <p>You must agree with the spectator code of conduct</p>
                    </div>
                  </div>

                    <template v-if="errors && !!Object.keys(errors).length">
                        <h3 class="text-red font-bold" style="font-size: 16px;">Please fix the following issues</h3>
                        <div v-for="(e, i) in errors" :key="'all_errors_' + i" class="form__error">
                            <p v-for="(e, i2) in e" :key="'all_errors_item' + i2" v-html="e"></p>
                        </div>
                    </template>

                </div>
              </div>
            </div>

            <div
              class="col col--6 mq-tab--12 js-delivery"
              v-if="
                requirements.includes('delivery.name') ||
                requirements.includes('delivery.address_line_1') ||
                requirements.includes('delivery.address_line_2') ||
                requirements.includes('delivery.city') ||
                requirements.includes('delivery.county') ||
                requirements.includes('delivery.postcode')
              "
            >
              <div class="col__inner">
                <div class="checkout__box">
                  <h2 class="checkout__box__ttl">
                    {{ __("Delivery Address") }}
                  </h2>

                  <div class="form__field">
                    <label>
                      <input
                        @change="syncDeliveryWithBillingAddress()"
                        type="checkbox"
                        id="sameAsBillingAddress"
                        name="sameAsBillingAddress"
                        v-model="sameAsBillingAddress"
                      />
                      Same as billing address
                    </label>
                  </div>

                  <div class="form__field">
                    <input
                      type="text"
                      name="name"
                      id="name"
                      class="form__input form__input--secondary"
                      :placeholder="__('Name')"
                      v-model="fields.delivery.name"
                      v-if="requirements.includes('delivery.name')"
                      :disabled="sameAsBillingAddress"
                    />

                    <div
                      class="form__error"
                      v-if="
                        typeof errors['fields.delivery.name'] != 'undefined'
                      "
                    >
                      <p
                        v-for="(e, i) in errors['fields.delivery.name']"
                        :key="'delivery_name' + i"
                        v-html="e"
                      ></p>
                    </div>
                  </div>
                  <div class="form__field">
                    <input
                      type="text"
                      name="address_line_1"
                      id="address_line_1"
                      class="form__input form__input--secondary"
                      :placeholder="__('Address Line 1')"
                      v-model="fields.delivery.address_line_1"
                      v-if="requirements.includes('delivery.address_line_1')"
                      :disabled="sameAsBillingAddress"
                    />

                    <div
                      class="form__error"
                      v-if="
                        typeof errors['fields.delivery.address_line_1'] !=
                        'undefined'
                      "
                    >
                      <p
                        v-for="(e, i) in errors[
                          'fields.delivery.address_line_1'
                        ]"
                        :key="'delivery_address_line_1' + i"
                        v-html="e"
                      ></p>
                    </div>
                  </div>
                  <div class="form__field">
                    <input
                      type="text"
                      name="address_line_2"
                      id="address_line_2"
                      class="form__input form__input--secondary"
                      :placeholder="__('Address Line 2')"
                      v-model="fields.delivery.address_line_2"
                      v-if="requirements.includes('delivery.address_line_2')"
                      :disabled="sameAsBillingAddress"
                    />

                    <div
                      class="form__error"
                      v-if="
                        typeof errors['fields.delivery.address_line_2'] !=
                        'undefined'
                      "
                    >
                      <p
                        v-for="(e, i) in errors[
                          'fields.delivery.address_line_2'
                        ]"
                        :key="'delivery_address_line_2' + i"
                        v-html="e"
                      ></p>
                    </div>
                  </div>
                  <div class="form__field">
                    <input
                      type="text"
                      name="city"
                      id="city"
                      class="form__input form__input--secondary"
                      :placeholder="__('City')"
                      v-model="fields.delivery.city"
                      v-if="requirements.includes('delivery.city')"
                      :disabled="sameAsBillingAddress"
                    />

                    <div
                      class="form__error"
                      v-if="
                        typeof errors['fields.delivery.city'] != 'undefined'
                      "
                    >
                      <p
                        v-for="(e, i) in errors['fields.delivery.city']"
                        :key="'delivery_city' + i"
                        v-html="e"
                      ></p>
                    </div>
                  </div>
                  <div class="form__field">
                    <input
                      type="text"
                      name="county"
                      id="county"
                      class="form__input form__input--secondary"
                      :placeholder="__('County')"
                      v-model="fields.delivery.county"
                      v-if="requirements.includes('delivery.county')"
                      :disabled="sameAsBillingAddress"
                    />

                    <div
                      class="form__error"
                      v-if="
                        typeof errors['fields.delivery.county'] != 'undefined'
                      "
                    >
                      <p
                        v-for="(e, i) in errors['fields.delivery.county']"
                        :key="'delivery_county' + i"
                        v-html="e"
                      ></p>
                    </div>
                  </div>
                  <div class="form__field">
                    <input
                      type="text"
                      name="postcode"
                      id="postcode"
                      class="form__input form__input--secondary"
                      :placeholder="__('Postcode')"
                      v-model="fields.delivery.postcode"
                      v-if="requirements.includes('delivery.postcode')"
                      :disabled="sameAsBillingAddress"
                    />

                    <div
                      class="form__error"
                      v-if="
                        typeof errors['fields.delivery.postcode'] != 'undefined'
                      "
                    >
                      <p
                        v-for="(e, i) in errors['fields.delivery.postcode']"
                        :key="'delivery_postcode' + i"
                        v-html="e"
                      ></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          id="btn-next"
          class="btn btn--tertiary"
          @click="save"
          v-if="tenant.id != 63"
        >
          {{ __("Next") }}
        </button>
        <button
          type="button"
          id="btn-next"
          class="btn btn--tertiary w-full"
          @click="save"
          v-else
        >
          {{ __("Next Step: Payment") }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import GoogleAddressAutocomplete from '../Fields/GoogleAddressAutocomplete.vue';
export default {
  components: {
    GoogleAddressAutocomplete
  },
  props: {
    tenant: {
      type: Object,
      required: true,
    },
    reservations: {
      required: false,
    },
    completed: {
      type: Boolean,
      required: true,
    },
    method: {
      type: String,
      required: true,
    },
    ticket: {
      type: String,
      required: true,
    },
    spectatorCodeOfConduct: {
      type: Boolean,
      required: true,
    },
    address: {
      required: false,
    },
    howDidYouHearAboutUsOptions: {
      required: false
    }
  },

  data: () => ({
    hide: false,
    requirements: [],
    spectator_code_of_conduct: 0,
    spectator_code_of_conduct_error: false,
    order: false,
    showSearchClearButton: false,
    sameAsBillingAddress: false,
    fields: {
      notes: "",
      how_did_you_hear_about_us: null,
      how_did_you_hear_about_us_other: null,
      additional_info: null,
      billing: {
        name: "",
        first_name: "",
        surname: "",
        email: "",
        telephone: "",
        address_line_1: "",
        address_line_2: "",
        city: "",
        county: "",
        postcode: "",
        terms: 0,
        marketing_opt_in: window.website.marketing_opt_in_default_value
      },
      delivery: {
        name: "",
        address_line_1: "",
        address_line_2: "",
        city: "",
        county: "",
        postcode: "",
      },
    },
    errors: {},
  }),
  mounted() {
    this.$emit("loading", true);

    axios
      .get(`/checkout/fields?method=${this.method}&ticket=${this.ticket}`)
      .then((response) => {
        this.hide = true;

        if (response.data.length <= 0) {
          this.$emit("update", {});
          this.$emit("next");
        } else {
          this.requirements = response.data;
          this.hide = false;
          this.$emit("loading", false);
        }
      });
  },
  created() {
    if (this.address) {
      this.fields.billing.name = this.address.name;
      this.fields.billing.email = this.address.email;
      this.fields.billing.telephone = this.address.telephone;
      this.fields.billing.address_line_1 = this.address.address_1;
      this.fields.billing.address_line_2 = this.address.address_2;
      this.fields.billing.city = this.address.town;
      this.fields.billing.county = this.address.county;
      this.fields.billing.postcode = this.address.postcode;
    }
  },
  methods: {
    save() {
      event.preventDefault();

      if (this.spectatorCodeOfConduct) {
        this.spectator_code_of_conduct_error = false;
        if (!this.spectator_code_of_conduct) {
          this.spectator_code_of_conduct_error = true;
          return false;
        }
      }

      this.fields.billing.name = [this.fields.billing.first_name, this.fields.billing.surname].filter((str) => str).join(' ');

      this.$emit("loading", true);
      this.errors = {};

      let nameParts = this.fields.billing.name.split(" ");
      window._klaviyoHelper.recordIdentity({
        $email: this.fields.billing.email,
        $first_name: nameParts.shift(),
        $last_name: nameParts.join(" "),
        full_name: this.fields.billing.name,
        address_line_1: this.fields.billing.address_line_1,
        address_line_2: this.fields.billing.address_line_2,
        city: this.fields.billing.city,
        county: this.fields.billing.county,
        postcode: this.fields.billing.postcode,
        telephone: this.fields.billing.telephone,
      });

      axios
        .post("/checkout/validation", {
          method: this.method,
          ticket: this.ticket,
          fields: this.fields,
        })
        .then((response) => {
          this.loading = false;
          this.$emit("update", this.fields);
          this.$emit("next");
        })
        .catch((error) => {
          if (error.response && error.response.status == 404) {
            window.location.href = "/booking";
          }
          this.$emit("loading", false);
          this.errors = error.response.data.errors;
        });
    },

    edit() {
      event.preventDefault();

      this.$emit("edit", true);
    },
    getAddressData: function (addressData, placeResultData, id) {
      var subpremise = '', address_1 = '', address_2 = '', address_3 = '', address_4 = '', postcode = '';

      for (const component of placeResultData.address_components) {
        const componentType = component.types[0];
        switch (componentType) {
          case "subpremise":
            subpremise = `${component.long_name}`;
            break;
          case "street_number":
            address_1 = `${component.long_name} ${address_1}`;
            break;
          case "route":
            address_1 += component.long_name;
            break;
          case "sublocality_level_1":
            address_2 = component.long_name;
            break;
          case "postal_code":
            postcode = `${component.long_name}${postcode}`;
            break;
          case "postal_code_suffix":
            postcode = `${postcode}-${component.long_name}`;
            break;
          case "postal_town":
            address_3 = component.long_name;
            break;
          case "locality":
            address_3 = component.long_name;
            break;
          case "administrative_area_level_2":
            if (!address_2) {
              address_2 = component.long_name;
            } else if (!address_3) {
              address_3 = component.long_name;
            } else {
              address_4 = component.long_name;
            }
            break;
          case "administrative_area_level_1":
            address_4 = component.long_name;
            break;
        }
      }

      if (subpremise) {
        address_1 = subpremise + ', ' + address_1;
      }
      if (address_2 === address_3 || address_3 === address_4) {
        address_3 = '';
      }

      this.fields.billing.address_line_1 = address_1;
      this.fields.billing.address_line_2 = address_2;
      this.fields.billing.city = address_3;
      this.fields.billing.county = address_4;
      this.fields.billing.postcode = postcode;
    },
    onAddressSearchChange() {
        if (this.$refs.googleAddressAutocompleteBillingField.autocompleteText) {
            this.showSearchClearButton = true;
        } else {
            this.showSearchClearButton = false;
        }
    },
    clearAddress() {
      this.fields.billing.address_line_1 = null;
      this.fields.billing.address_line_2 = null;
      this.fields.billing.city = null;
      this.fields.billing.county = null;
      this.fields.billing.postcode = null;
      this.$refs.googleAddressAutocompleteBillingField.clear();
    },
    syncDeliveryWithBillingAddress() {
      if (this.sameAsBillingAddress) {
        this.fields.delivery.name = this.fields.billing.name;
        this.fields.delivery.address_line_1 = this.fields.billing.address_line_1;
        this.fields.delivery.address_line_2 = this.fields.billing.address_line_2;
        this.fields.delivery.town = this.fields.billing.city;
        this.fields.delivery.county = this.fields.billing.county;
        this.fields.delivery.postcode = this.fields.billing.postcode;
      }
    }
  },
  watch: {
    "fields.billing": {
      handler(value) {
        this.syncDeliveryWithBillingAddress();
      },
      deep: true
    }
  }
};
</script>
<style lang="scss">

#google-address-autocomplete-billing-wrapper {
  position: relative;
  .search-icon {
    position: absolute;
    padding: 10px;
    min-width: 40px;
    z-index: 9999;
  }
  .clear-icon {
    position: absolute;
    right: 0px;
    padding: 10px;
    min-width: 40px;
    z-index: 9999;
    cursor: pointer;
  }
  #google-address-autocomplete-billing {
    padding: 15px 15px 15px 45px;
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/Checkout/Fields.vue